import { render, staticRenderFns } from "./FormatSelector.vue?vue&type=template&id=6fbbbd4b"
import script from "./FormatSelector.vue?vue&type=script&lang=js"
export * from "./FormatSelector.vue?vue&type=script&lang=js"
import style0 from "./FormatSelector.vue?vue&type=style&index=0&id=6fbbbd4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports